import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "report-conflict-modal",
  "data-keyboard": "true",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "report-conflict-modal-title",
  "aria-hidden": "true"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"modal-header\"><h5 class=\"modal-title\" id=\"report-conflict-modal-title\"> Conflict detected </h5><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">×</span></button></div><div class=\"modal-body\"><p>This Report has been updated since you last saved/opened it.</p><ul class=\"list-unstyled alert alert-danger\"><li><strong>Use mine</strong> to overwrite the saved Report with your current version.</li><li>Any changes <strong>someone else</strong> has made to this report will be lost.</li></ul><ul class=\"list-unstyled alert alert-danger\"><li><strong>Use theirs</strong> to discard your edits and download the latest Report.</li><li>Any changes <strong>you</strong> have made to this report may be lost.</li></ul><p class=\"lead\">What do you want to do?</p></div>", 2)

import $ from 'jquery';
import { computed, inject, ref } from 'vue';
import { useStore } from 'vuex';
import { useToast } from "vue-toastification";
import _ from 'lodash';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportConflictModal',
  setup(__props, { expose: __expose }) {

const store = useStore();
const toasted = useToast();
const actProperty: any = inject('actProperty');

const report = computed(() => store.getters['reports/current']);

const getReport = async (ref: string): Promise<any> => {
  return await store.dispatch('reports/getReport', ref);
};

const updateReport = async (payload: {force: boolean}): Promise<any> => {
  return await store.dispatch('reports/updateReport', payload);
};

const useMine = async (): Promise<void> => {
  actProperty.confirmPrompt('Use mine?')
    .then(() => updateReport({force: true}))
    .then(() => toasted.success('Report saved'))
    .catch((err: any) => actProperty.displayError(err));
};

const useTheirs = async (): Promise<void> => {
  actProperty.confirmPrompt('Use theirs?')
    .then(() => getReport(report.value.ref))
    .then(() => toasted.success('Report downloaded'))
    .catch((err: any) => actProperty.displayError(err));
};


const show = () => {
  if ($('#report-conflict-modal-Backdrop').length == 0) {
    const backdropDiv = $('<div class="modal-backdrop fade show" id="report-conflict-modal-Backdrop"></div>');
    $('body').append(backdropDiv);
    $(`#report-conflict-modal`).show();
  }
}
const hide = () => {
  if ($('#report-conflict-modal-Backdrop').length > 0) {
    $('#report-conflict-modal-Backdrop').remove();
    $(`#report-conflict-modal`).hide();
  }
};
__expose({show, hide });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "modal-dialog modal-dialog-centered",
      role: "document"
    }, [
      _createElementVNode("div", { class: "modal-content" }, [
        _hoisted_2,
        _createElementVNode("div", { class: "modal-footer" }, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-danger mr-auto",
            "data-dismiss": "modal",
            onClick: useMine
          }, "Use mine"),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-danger",
            "data-dismiss": "modal",
            onClick: useTheirs
          }, "Use theirs")
        ])
      ])
    ])
  ]))
}
}

})